export default defineNuxtRouteMiddleware(async (to, from) => {
  const urlPath = to.path.replace(/^\/[a-z]{2}-[A-Z]{2}/, "");
  const builderStore = useBuilderStore();
  let model = "page";
  const isEventPage = urlPath.startsWith('/events');
  if (isEventPage) model = "events";

  const pageData = await builderStore.getItem(model, { urlPath },{},{fields:'id'});

  if (!pageData) {
    throw createError({
      statusCode: 404,
      statusMessage: "404 - Page Not Found",
    });
  }
  if (pageData) {
    return;
  }
})
